import { DataGrid } from "@mui/x-data-grid";
import { useMemo } from "react";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import { getColumns } from "./columns";

const dataGridCustomStyles = {
  border: "none",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f5f5f5",
    borderRadius: 1,
  },
  "& .MuiDataGrid-cell": {
    color: "#383E49",
    fontFamily: "Lexend",
    fontWeight: 500,
  },
  "& .onhold-row": {
    backgroundColor: "#ffe0b2",

    "& .MuiDataGrid-cell": {
      fontFamily: "Lexend",
      fontWeight: 500,
    },
  },
  "& .canceled-row": {
    backgroundColor: "#ffebee",
    "& .MuiDataGrid-cell": {
      fontFamily: "Lexend",
      fontWeight: 500,
    },
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontFamily: "lexend",
    fontSize: "14px",
    fontWeight: 500,
    color: "#667085",
  },
  "& .MuiDataGrid-row": {
    cursor: "pointer",
  },
};

const OrdersDataGrid = ({
  isLatestOrders,
  gridRows,
  hasReason,
  shouldHideStatus,
  isDelayPicking,
  isFakeCustomerOrder,
  type,
  selectedJobIds,
  setSelectedJobIds,
  handleRowClick,
  loading,
  isCheckBoxSelection,
  paginationModel,
  rowCount,
  sortModel,
  handleSortModelChange,
  setPaginationModel,
}) => {
  const columns = useMemo(() => {
    return getColumns(
      hasReason,
      shouldHideStatus,
      isDelayPicking,
      isFakeCustomerOrder,
      type
    );
  }, [hasReason, shouldHideStatus, isDelayPicking, isFakeCustomerOrder, type]);

  const getRowId = (row) => {
    return row.job_id;
  };

  const getRowClassName = (params) => {
    switch (params.row.status) {
      case "On Hold":
        return "onhold-row";

      case "Canceled":
        return "canceled-row";
      default:
        return "";
    }
  };

  return (
    <DataGrid
      getRowId={getRowId}
      rows={gridRows}
      columns={columns}
      autoHeight
      checkboxSelection={isCheckBoxSelection}
      onRowSelectionModelChange={(newSelectionModel) => {
        setSelectedJobIds(newSelectionModel);
      }}
      rowSelectionModel={selectedJobIds}
      disableRowSelectionOnClick
      onRowClick={(params) => handleRowClick(params)}
      getRowClassName={(params) => getRowClassName(params)}
      sx={{
        ...dataGridCustomStyles,
        ...(isLatestOrders && {
          ".MuiTablePagination-root, .MuiDataGrid-footerContainer": {
            display: "none",
          },
        }),
      }}
      {...(!isLatestOrders && {
        paginationMode: "server",
        sortingMode: "server",
        onSortModelChange: handleSortModelChange,
        sortModel: sortModel, // Controlled sort model
        rowCount,
        paginationModel,
        onPaginationModelChange: setPaginationModel,
        pageSizeOptions: [20, 50, 100],
      })}
      loading={loading}
      slots={{
        loadingOverlay: CustomLoadingOverlay,
      }}
    />
  );
};

export default OrdersDataGrid;
